<span class="question">
  <label class="question_text" for="question_{{id}}" tabindex="0">{{text}}</label>
  {{#if textbox}}
    <input data-question-id="{{id}}" id="question_{{id}}" class="question_element" type="text" />
  {{else}}
    <select data-question-id="{{id}}" id="question_{{id}}" class="question_element">
      <option value=""></option>
      {{#each answers}}
        <option value="{{id}}">{{text}}</option>
      {{/each}}
    </select>
  {{/if}}
</span>
